import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import 'bootstrap/dist/css/bootstrap.min.css';
import AdminLayout from './pages/AdminLayout';
import UserLayout from './pages/UserLayout';
import { routes } from './routes';

const App = () => {
  
  return (
    <Router>
      <Routes>
        {/* Διαδρομή για Login */}
        <Route path="/login" element={<Login />} />

        {/* Διαδρομή για User Layout, μόνο για μη-admin χρήστες */}
        <Route
          path="/user/*"
          element={
            <PrivateRoute adminOnly={false}>
              <UserLayout />
            </PrivateRoute>
          }
        />
        {/* Διαδρομή για Admin Layout, μόνο για admin */}
        <Route
          path="/admin/*"
          element={
            <PrivateRoute adminOnly={true}>
              <AdminLayout routes={routes} />
            </PrivateRoute>
          }
        />

        {/* Default διαδρομή */}
        <Route path="*" element={<Login />} />
      </Routes>
    </Router>
  );
};

export default App;
